import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import { postData, getData } from '../../../Services/NodeServices';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../../Digital Card Assets/newlogo.png'
import {
  Button,
  Container,
  Grid,
  IconButton,
  Paper,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import ReviewEdgeDrawer from './LoginDrawer';
import ReviewRating from './ReviewRating';
const ContactHome = () => {

  const { id } = useParams();

  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down(600));
  const tablet = useMediaQuery(theme.breakpoints.down(960));
  const [result, setResult] = useState('')
  const [display, setDisplay] = useState('none')
  const [data, setData] = useState(null)
  const [download, setDownload] = useState(false)
  const navigate = useNavigate();

  const checkTagId = async () => {

    const formData = new FormData;
    formData.append("tagId", id)
    const response = await postData('contact/chkTagId', formData, true)
    setResult(response.data)
    if (response.status == 'false') {
      setDisplay('block')
    }
    else {
      if (response.data.status == 'Active' && response.data.contactPhone && response.data.contactPhone != '') {
        setDisplay('block')
        setDownload(true)
        setData(response.data)
      } else {
        navigate('/digitalcardlogin')
      }
    }

  }

  useEffect(() => {
    checkTagId()
  }, [])


  const handleSave = () => {
    var vCardData =
        "BEGIN:VCARD\r\n" +
        "VERSION:3.0\r\n" +
        `FN:${data.contactName}\r\n` +
        `N:${data.contactName};;;\r\n` +
        `TEL;TYPE=CELL:${data.contactPhone}\r\n` +
        `EMAIL:${data.contactEmail}\r\n` +
        "END:VCARD";
      
        var blob = new Blob([vCardData], { type: "text/vcard" });
        var downloadLink = document.createElement("a");
        downloadLink.href = URL.createObjectURL(blob);
        downloadLink.download = `${data.contactName}.vcf`;
        downloadLink.style.display = "none";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
  }




  return (
    <Grid sx={{ display: "flex", justifyContent: 'center' }}>
      <Grid container spacing={2} sx={{ display: display, width: 450 }}>
        <Grid item xs={12} sx={{ backgroundColor: '#F3B419', borderBottomLeftRadius: '50%', borderBottomRightRadius: "50%", paddingBottom: 10 }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <img style={{ height: 180, width: 180, }} src={logo} />
          </div>
        </Grid>
        <Grid item xs={12} class='welcome' sx={{ display: "flex", justifyContent: 'center', fontSize: 60, marginBottom: 3, color: '#000' }}>
          Welcome
        </Grid>
        {download ?
          <>
            <Grid item xs={12} class={tablet ? 'activate' : 'activate1'} sx={{ display: "flex", justifyContent: 'center', textAlign: "center", backgroundColor: '#F3B419', borderRadius: 2, paddingBottom: "16px", color: 'black', fontSize: { xs: 55, md: 34 } }}>
              Save My Contact!
            </Grid>
            <Grid item xs={12} sx={{ display: "flex", justifyContent: 'center' }}>
              <Button onClick={handleSave} variant='contained' sx={{ fontSize: 25, backgroundColor: '#F3B419', color: "black", "&:hover": { backgroundColor: '#F3B419' } }}>
                <Typography class='font'>
                  Save
                </Typography>
              </Button>
            </Grid>
          </> : <>
            <Grid item xs={12} class={tablet ? 'activate' : 'activate1'} sx={{ display: "flex", justifyContent: 'center', textAlign: "center", backgroundColor: '#F3B419', borderRadius: 2, paddingBottom: "16px", color: 'black', fontSize: { xs: 55, md: 34 } }}>
              Activate your Cards here !
            </Grid>
            <Grid item xs={12} sx={{ display: "flex", justifyContent: 'center' }} >
              <ReviewEdgeDrawer tagId={id} />
            </Grid>
          </>}
      </Grid>
    </Grid>
  )
}

export default ContactHome
